import { LocalLaundryService } from '@mui/icons-material';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
let refreshingPromise = null;
const refreshAccessToken = async () => {
    const GET_TOKEN_QUERY = `
    mutation ($body: RefreshTokenInput!) {
        generateNewAccessToken(body: $body) {
            accessToken
            refreshToken
        }
    }
`;

    const refreshtoken = localStorage.getItem('diologRefToken');

    if (!refreshtoken) {
        return false;
    }
    try {
        let submitData = { query: GET_TOKEN_QUERY, variables: { body: { refreshtoken } } };
        const response = await axios({
            method: 'POST',
            url: process.env.REACT_APP_API_BASE_URL,
            data: submitData
        });

        const { accessToken, refreshToken } = response.data.data.generateNewAccessToken;
        localStorage.setItem('diologAuthToken', accessToken);
        localStorage.setItem('diologRefToken', refreshToken);
        return accessToken;
    } catch (e) {
        localStorage.clear();
        window.location.replace('/');
        throw e;
    }
};

// Initial token check and setup refresh

let url = process.env.REACT_APP_API_BASE_URL;
const instance = axios.create({
    baseURL: url
});
instance.interceptors.request.use(
    async function (config) {
        let accessToken = localStorage.getItem('diologAuthToken');
        if (accessToken) {
            if (refreshingPromise) {
                accessToken = await refreshingPromise;
            }
            const claims = jwtDecode(accessToken);
            const expiration = new Date(claims.exp * 1000);
            const now = new Date();
            now.setSeconds(now.getSeconds() - 10);
            if (now > expiration) {
                if (!refreshingPromise) {
                    refreshingPromise = refreshAccessToken();
                }
                accessToken = await refreshingPromise;
                refreshingPromise = null;
            }

            if (accessToken && config.headers) {
                config.headers.Authorization = `${accessToken}`;
            }
        }
        return config;
        // const token = localStorage.getItem('diologAuthToken');
        // if (token) {
        //     config.headers.Authorization = token;
        // }
        // return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(async function (config) {
    if (config.data.errors && config.data.errors[0].message === 'Unauthorized') {
        localStorage.clear();
        window.location.replace('/');
    }
    return config;
});
export default instance;
